import {ChangeEvent, useState, useContext, useEffect} from "react";
import {useHistory} from "react-router-dom";
import {Container, Box, Typography, Grid} from "@mui/material";
import {useLangContext} from '../../../../shared/features/Language';
import {useConsumerArtApi} from "../../api";
import {ImageContext} from "../../../../shared/tools/image/imageContext";
import {LinkButton} from "../../../../shared/components";
import {CustomButton} from "../../../../shared/components/Buttons/CustomButton";
import bgImage from "shared/assets/img/bg02.jpg";
import './EmailCheckView.scss';
import {useConsumerCodeStorage} from "../../../auth";

export const EmailCheckView = () => {
  const {textData, lang} = useLangContext();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');  
  const [validEmail, setValidEmail] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const {startArt, generateArt} = useConsumerArtApi();
  const {setUserEmail, schema, setSessionId, setLoadingStatus} = useContext(ImageContext);
  const consumerCodeStorage = useConsumerCodeStorage();
  const history = useHistory();
  const testEmailRegex = new RegExp("^[\\w.-]+@[\\w.-]+\\.[a-zA-Z]{2,}$", "g");

  if (!schema || !schema.length) history.push('/');

  const handlerInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  }

  const handlerSend = () => {
    setUserEmail(email);
    setShowConfirmation(true);
  }

  const handlerConfirm = async () => {
    try {
      setLoadingStatus(true);
      setError("");

      const res = await startArt({
        email,
        lastStep: "[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]",
        code: consumerCodeStorage.get(),
        stepsData: JSON.stringify(schema),
        totalStepCount: 4096
      });

      setSessionId(res.sessionId);
 
      await generateArt({
            email,
            name: email,
            languageId: lang,
            debug: false,
          });

      history.push('/email-send')
    } catch (e) {
      let errorCode = "INVALID_PDF_GENERATION";

      if (e?.data?.title) {
        errorCode = e.data.title;
      }

      console.error(errorCode);
      // let errorMessage = textData.errorInvalidPdfGeneration;
      // if (errorCode === "INVALID_EMAIL")
      // {
      //   errorMessage = textData.errorCouponLimit;
      // }
      // setError(errorMessage);
      setError(textData.errorCouponLimit);
    } finally {
      setLoadingStatus(false)
    }
  }

  useEffect(() => {
    setValidEmail(
      testEmailRegex.test(email)
    );
  }, [email]);

  useEffect(() => {
    const handlePopState = () => {
      history.push('/art-create');
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <Container
      sx={{
        height: '100%',
        maxWidth: {lg: '980px', xs: '980px' },
        marginTop: {lg: '50px', xs: '10px' },
        marginInline: 'auto',
      }}
      className='email-view'
    >
      {showConfirmation ? (
        <Box sx={{textAlign: 'center'}}>
          {/* Show Email Confirmation */}
          <div className="bg-holder">
            <div className="bg-instance-1" style={{backgroundImage: `url(${bgImage})`}}></div>
            <div className="bg-instance-2" style={{backgroundImage: `url(${bgImage})`}}></div>
          </div>
          <Typography
            variant='body2'
            sx={{
              marginBottom: {lg: '40px', xs: '10px'},
            }}
            className='typography-body2'
          >{textData.emailInstructionConfirm}</Typography>

          {!!error && (
              <Typography
                sx={{
                  fontSize: {lg: '20px', xs: '14px'},
                  fontWeight: 300,
                  lineHeight: '120%',
                  color: '#F00',
                }}
              >
                {textData.errorCouponLimit}
              </Typography> 
          )}  
          <div className='email-wrapper'>
            <span>{email}</span>

          </div>

          <Typography
            variant='body2'
            sx={{
              marginBottom: {lg: '40px', xs: '10px'},
            }}
            className='typography-body2'
          >{textData.emailConfirmation}</Typography>

          <Grid container
                sx={{
                  gap: '40px',
                  justifyContent: 'center',
                }}
          >
            <Grid item>
              <CustomButton
                color='secondary'
                width={{ lg: '200px', xs: '150px' }}
                onClick={() => {
                  setEmail(email);
                  setShowConfirmation(false)
                }}
              >{textData.buttonCaptionNo}</CustomButton>
            </Grid>
            <Grid item>
              <CustomButton
                width={{ lg: '200px', xs: '150px' }}
                disabled={!email}
                onClick={handlerConfirm}
              >{textData.buttonCaptionYes}</CustomButton>
            </Grid>
          </Grid>

        </Box>
      ) : (
        <Box sx={{textAlign: 'center'}}>
          {/* Get Email */}
          <Typography
            variant='body2'
            sx={{
              marginBottom: {lg: '40px', xs: '10px'}
            }}
            className='typography-body2'
          >{textData.motivationEmailInput}</Typography>
          <div className="input-wrapper">
            <input type="email" placeholder={textData.emailPlaceholder} value={email} onChange={handlerInputChange}/>
          </div>
          <Typography sx={{
            fontSize: '12px',
            color: '#8e8e8e',
            marginBottom: '50px'
          }}>
            {textData.emailAdditionalText}
          </Typography>
          <Grid container
                sx={{
                  gap: '40px',
                  justifyContent: 'center',
                }}
          >
            <Grid item>
              <LinkButton
                to={'/image-upload'}
                width={{ lg: '250px', xs: '150px' }}
                color='secondary'
              >{textData.buttonCaptionBack}</LinkButton>
            </Grid>
            <Grid item>
              <CustomButton
                width={{ lg: '250px', xs: '150px' }}
                disabled={!validEmail}
                onClick={handlerSend}
              >{textData.buttonCaptionSend}</CustomButton>
            </Grid>
          </Grid>
        </Box>
      )}
    </Container>
  )
}
